import { useReducer } from 'react';
import { useSwipeable } from 'react-swipeable';
export const nextPage = (current, total) => (current + 1) % total;
export const previousPage = (current, total) => (total - ((total - current + 1) % total)) % total;
function reducer(state, action) {
    switch (action.type) {
        case 'NEXT_PAGE': {
            // If `state.infinite` is true, we need to take into account an extra
            // page in the calculation. This extra page is a clone of the first page.
            const adjustedTotalPages = state.infinite
                ? state.totalPages + 1
                : state.totalPages;
            const nextPageIndex = nextPage(state.currentPage, adjustedTotalPages);
            const nextItemIndex = (nextPageIndex % adjustedTotalPages) * state.itemsPerPage;
            return {
                ...state,
                sliding: true,
                slideDirection: 'next',
                currentItem: nextItemIndex,
                currentPage: nextPageIndex,
            };
        }
        case 'PREVIOUS_PAGE': {
            // If `state.infinite` is true, we need to take into account an extra
            // page in the calculation. This extra page is a clone of the first page.
            const adjustedTotalPages = state.infinite
                ? state.totalPages + 1
                : state.totalPages;
            // If `state.infinite` is true and we're currently on page 0, we need to
            // let the slider go to page -1. This -1 page is a clone of the last page.
            const shouldGoToClone = state.infinite && state.currentPage === 0;
            const previousPageIndex = shouldGoToClone
                ? -1
                : previousPage(state.currentPage, state.totalPages);
            return {
                ...state,
                sliding: true,
                slideDirection: 'previous',
                currentItem: (previousPageIndex % adjustedTotalPages) * state.itemsPerPage,
                currentPage: previousPageIndex,
            };
        }
        case 'GO_TO_PAGE': {
            if (action.payload.pageIndex === state.currentPage) {
                return state;
            }
            return {
                ...state,
                sliding: action.payload.shouldSlide,
                slideDirection: action.payload.pageIndex > state.currentPage ? 'next' : 'previous',
                currentItem: (action.payload.pageIndex % state.totalPages) * state.itemsPerPage,
                currentPage: action.payload.pageIndex,
            };
        }
        case 'STOP_SLIDE':
            return { ...state, sliding: false };
        default:
            return state;
    }
}
const defaultSliderState = (totalItems, itemsPerPage, infinite) => ({
    currentItem: 0,
    currentPage: 0,
    sliding: false,
    slideDirection: 'next',
    totalItems,
    itemsPerPage,
    totalPages: Math.ceil(totalItems / itemsPerPage),
    infinite,
});
const slide = (page, dispatch) => {
    if (page === 'next') {
        dispatch({
            type: 'NEXT_PAGE',
        });
    }
    if (page === 'previous') {
        dispatch({
            type: 'PREVIOUS_PAGE',
        });
    }
    if (typeof page === 'number') {
        dispatch({
            type: 'GO_TO_PAGE',
            payload: {
                pageIndex: page,
                shouldSlide: true,
            },
        });
    }
};
export default function useSlider({ totalItems, itemsPerPage = 1, infiniteMode = false, ...swipeableConfigOverrides }) {
    const [sliderState, sliderDispatch] = useReducer(reducer, undefined, () => defaultSliderState(totalItems, itemsPerPage, infiniteMode));
    const handlers = useSwipeable({
        onSwipedRight: () => slide('previous', sliderDispatch),
        onSwipedLeft: () => slide('next', sliderDispatch),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
        ...swipeableConfigOverrides,
    });
    return {
        handlers,
        slide,
        sliderState,
        sliderDispatch,
    };
}
//# sourceMappingURL=useSlider.js.map